import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { AuthProvider } from './app/providers/AuthProvider';
import { SubscriptionProvider } from './app/providers/SubscriptionProvider';
import { AppRoutes } from './app/routes/AppRoutes';
import './core/config/aws_config';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <SubscriptionProvider>
        <AppRoutes />
      </SubscriptionProvider>
    </AuthProvider>
  </React.StrictMode>
);